import styled from "styled-components";
import { responsive } from "Styles/Constants";
import { COLORS } from "Styles/Constants";

//IMAGES
import FooterBottom from "../../Assets/Images/Footer/footer-bottom.svg";
import FooterCtaTop from "../../Assets/Images/Footer/footer-cta-top.svg";
import FooterCopyVector from "../../Assets/Images/Footer/footer-copyright-vector.svg";

export const FooterContainer = styled.div`
font-family: outfit, sans-serif;
     .footers_cta{
        background-color: #ACEBFF;
        padding: 30px 0;
        position: relative;
        width: 100%;
        overflow: hidden;
        &:after{
            content: "";
            position:absolute;
            background: url(${FooterCtaTop}) no-repeat;
            width:100%;
            height:100%;
            top: 0;
            right: 0;
            background-position: 65% top;
            background-size: 530px;
        }
        .mygrid-row {
            justify-content: space-between;
        }
        .mygrid-container{
            z-index:1;
            position: relative;
        }
        .footers_cta_desc {
            max-width: 775px;
            width: 100%;
            p{
                margin-top: 0;
                margin-bottom:10px;
            }
        }
        .footers_cta_btn {
            text-align: right;
            display: flex;
            align-items: center;
            justify-content: flex-end;
        }
    }
    .footer-bottom-main{
        background: #FFF9EB;
        position:relative;
        overflow:hidden;
       
        &:before{
            content: "";
            position:absolute;
            background: url(${FooterBottom}) no-repeat;
            width:100%;
            height:100%;
            top: 0;
            right: 0;
            background-position: 65% top;
            background-size: 500px;
        }
        &:after{
            content: "";
            position:absolute;
            background: url(${FooterCopyVector}) no-repeat;
            width:100%;
            height:100%;
            background-size: 471px;
            background-position: bottom left;
            bottom: 0;
            left: -50px;
        }
        .mygrid-container{
            z-index:1;
            position: relative;
        }
        .footer_bottom {
            padding-top: 70px;
            padding-bottom: 20px;
        }
    }
    .copyright_footer {
        .mygrid-container {
            padding-top: 52px;
            padding-bottom: 52px;
            border-top: 1px solid #A7A7A7;
        }
        .mygrid-row{

        }
        a{
            color: #ee2d2f;
            text-decoration:none;
            font-weight: 700;
            &:hover{
                color: #021E40;
            }
        }
    }
    .credit_txt_col {
        text-align: right;
    }
    h5.social_media_title {
        font-size: 22px;
        font-style: normal;
        font-weight: 600;
        color: #000;
        margin-top: 19px;
    }
    .footer-social ul {
        display: flex;
        align-items: center;
        margin-bottom: 10px;
        li{
            a{
                padding: 0px 11px;
                display: block;
                padding-bottom: 0;
                &:first-child{
                    padding-left:0px;
                }
            }
        }
    }
    .footer_cols{
        h4{
            color: #000;
            font-size: 23px;
            font-style: normal;
            font-weight: 600;
            margin-bottom:10px;
        }
        img.footer-logo {
            margin-bottom: 20px;
        }
        p{
            max-width: 334px;
            font-size: 16px;
        }
        .footer-social ul {
            margin: 0;
        }
        ul {
            list-style: none;
            padding: 0;
            text-decoration: none;
            li{
                margin-bottom:10px;
               li {
                margin-bottom: 10px;
                    a
                    {
                        font-size: 18px;
                        font-style: normal;
                        font-weight: 300;
                        color: #000;
                        text-decoration: none;
                        cursor: pointer;

                        &:hover {
                        color: #ee2d2f;
                        }
                    }
                    span {
                        font-size: 18px;
                        font-style: normal;
                        font-weight: 300;
                        color: #000;
                        text-decoration: none;
                        cursor: pointer;

                        &:hover {
                        color: #ee2d2f;
                        }
                    }
                }
            }
        }
    }

.footer_cols ul li a, .footer_cols ul li span{
    font-size: 18px;
    font-style: normal;
    font-weight: 300;
    color: #000;
    text-decoration: none;
    cursor: pointer;    
}
.footer_cols ul li a:hover, .footer_cols ul li span:hover{
    color: #ee2d2f;
}

.credit_txt {
    display: flex;
    align-items: center;
    justify-content: flex-end;
}

.credit_txt img {
    width: 100%;
    max-width: 115px;
    margin-left: 10px;
}

@media (max-width: 1199px) {
    .footers_cta .footers_cta_desc {
        max-width: 100%;
        width: 100%;
    }
    .footers_cta .footers_cta_btn {
        text-align: center;
        justify-content: center;
        margin-top: 34px;
    }
}
@media (max-width: 991px) {
    .footers_cta {
        padding: 30px 20px;
    }
    .footer_logo_col{
        margin-bottom: 20px;
    }
}
@media (max-width: 767px) {
    .footer_cols-in {
        margin-bottom: 15px;
    }
    .copyright_footer .mygrid-container {
        padding-top: 20px;
        padding-bottom: 20px;
    }
    .footer-bottom-main:after {
        display:none;       
    }
    .footer-bottom-main:before {
        background-position: top right;
        background-size: 189px;
    }
    .copyright_txt {
        padding-bottom: 15px;
        text-align:center;
    }
    .credit_txt_col {
        text-align: center;
        width: 100%;
    }
    .footers_cta {
        padding: 30px 20px;

    }
    .footer-social ul li a {
        padding: 16px;
        padding-bottom: 0;
    }
    .credit_txt{
        justify-content:center;
    }
    .copyright_footer .copyright_txt_col {
        width: 100%;
    }
}`;
